import Parse from "parse";
import imageCompression from "browser-image-compression";
import { v4 as uuid } from 'uuid';
import { dataURLtoFile } from "../Helpers/ImageHelper";
import { endOfTheDay, startOfTheDay } from "../Helpers/DateConverter";

const appId = "quorum"

// Env-based: REACT_APP_PARSE_SERVER_URL for builds (prod: quorum-2, dev: quorum-parse-server)
// prod: https://quorum-2-33a5c18cbe7b.herokuapp.com
// dev:  https://quorum-parse-server.herokuapp.com
const baseUrl =
  process.env.REACT_APP_PARSE_SERVER_URL ||
  "https://quorum-2-33a5c18cbe7b.herokuapp.com"
const serverHostClean = baseUrl.replace(/\/parse\/?$/, "").replace(/\/$/, "")
const serverUrl = `${serverHostClean}/parse`

export const SERVER_PATH = {
  SERVER_URL: serverUrl,
  SERVER_HOST: serverHostClean
}

const compressOptions = {
  maxSizeMB: 1,
}

export const filterKeys = [
  "updatedAt",
  "createdAt",
  "date",
  "avatar",
  "image",
  "speaker",
  "speakers",
  "speakerFullName",
  "members",
  "password",
  "passwordSet",
  "pdfAttachment",
  "logoImage",
  "heroImage",
  "thumbnailImage",
  "location",
  "mentionedMembers"
]

export async function initParseServer() {
  if (Parse.serverURL === SERVER_PATH.SERVER_URL) {
    return
  }
  Parse.initialize(appId)
  Parse.serverURL = SERVER_PATH.SERVER_URL
}

export function getClassName(className) {
  return Parse.Object.extend(className)
}

export function setMinDateIfExists(parseQuery, date) {
  if (date) {
    parseQuery.greaterThanOrEqualTo("startDate", startOfTheDay(date))
  }
}

export function setMaxDateIfExists(parseQuery, date) {
  if (date) {
    parseQuery.lessThanOrEqualTo("startDate", endOfTheDay(date))
  }
}

export function setLimit(parseQuery, limit, skip) {
  if (limit === -1) {
    return
  }
  const skipCount = skip > 0 ? skip : 0
  const limitCount = limit > 0 ? limit : 0

  parseQuery.limit(limitCount)
  parseQuery.skip(skipCount)
}

export async function addImageIfExists(parseObject, image, imageKey) {
  if (image && typeof image === "object") {
    const compressedImage = await imageCompression(image, compressOptions);
    let parseImage = new Parse.File(uuid(), compressedImage);
    parseObject.set(imageKey, parseImage);
  }

  if (image && typeof image === "string" && image.startsWith("data:")) {
    const file = dataURLtoFile(image, uuid());
    await addImageIfExists(parseObject, file, imageKey);
  }
}

export function addFileOrNull(parseObject, file, key) {
  if (file !== null && typeof file === "object") {
    let parseFile = new Parse.File(uuid(), file, file.type);
    parseObject.set(key, parseFile);
  } else if (file === null) {
    parseObject.unset(key);
  }
}

export function convertToPointer(classname, id) {
  return {
    __type: "Pointer",
    className: classname,
    objectId: id,
  }
}

export function setACL(parseObject) {
  const acl = new Parse.ACL()
  acl.setRoleWriteAccess("Admin", true)
  acl.setRoleReadAccess("Admin", true)
  acl.setPublicReadAccess(true)
  parseObject.setACL(acl)
}
